import React from 'react';
import { Formik } from 'formik';
import {
  Button,
  Col,
  Row,
  Spinner,
} from 'react-bootstrap';
import { PaymentMethodValidation } from '../validation';
import TextField from '../../Partials/TextField';
import ReactSelectField from '../../Partials/ReactSelectField';
import states from '../../../../common/states';
import {
  PaymentMethod as PaymentMethodModel,
} from '../../../../structures/models/paymentMethod';
import {
  PaymentMethodRequest,
  SetupIntentPaymentMethodRequest,
} from '../../../../structures/requests/paymentMethod';

interface Props {
  currentPaymentMethod: PaymentMethodModel,
  handleSubmit: (
    data: SetupIntentPaymentMethodRequest | PaymentMethodRequest,
  ) => Promise<void>,
  isProcessing: boolean,
  setShowForm: React.Dispatch<React.SetStateAction<boolean>>,
}

const EditExistingPaymentMethod: React.FC<Props> = ({
  currentPaymentMethod,
  handleSubmit,
  isProcessing,
  setShowForm,
}) => {
  return (
    <div>
      <Formik
        initialValues={{
          ...currentPaymentMethod,
          country: currentPaymentMethod.country || 'US',
        }}
        validateOnChange={true}
        validationSchema={PaymentMethodValidation}
        onSubmit={handleSubmit}
      >
        {(formikProps) => {
          return (
            <div className="form">
              <div className="alert alert-info">
                Currently Editing CreditCard ending in:
                {currentPaymentMethod.cc_number}
              </div>
              <Row>
                <Col xs={12} md={6}>
                  <TextField
                    formikProps={formikProps}
                    fieldName="name"
                    visibleName="Full Name"
                  />
                </Col>
                <Col xs={12}>
                  <TextField
                    formikProps={formikProps}
                    fieldName="address_1"
                    visibleName="Address"
                  />
                </Col>
                <Col xs={12}>
                  <TextField
                    formikProps={formikProps}
                    fieldName="address_2"
                    visibleName="Address (con.)"
                  />
                </Col>
                <Col xs={6} md={4}>
                  <TextField
                    formikProps={formikProps}
                    fieldName="city"
                    visibleName="City"
                  />
                </Col>
                <Col xs={6} md={4}>
                  <ReactSelectField
                    formikProps={formikProps}
                    fieldName="state"
                    visibleName="State"
                    placeholder="- Select State -"
                    possibleValues={states.map((state) => ({
                      value: state.abbreviation,
                      label: state.name,
                    }))}
                  />
                </Col>
                <Col xs={6} md={4}>
                  <TextField
                    formikProps={formikProps}
                    fieldName="zip"
                    visibleName="Zip"
                  />
                </Col>
                <Col xs={12}>
                  <Button
                    type="submit"
                    disabled={isProcessing}
                    onClick={() => {
                      formikProps.handleSubmit();
                    }}
                    className="mr-2"
                  >
                    {isProcessing ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Loading...</span>
                      </>
                    ) : (
                      <>Update Card</>
                    )}
                  </Button>
                  <Button
                    disabled={isProcessing}
                    onClick={() => {
                      setShowForm(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default EditExistingPaymentMethod;
